export default __webpack_public_path__ + "static/media/area-13.47972bee.jpg";